export const locale = {
    lang: 'ds',
    data: {
        'Headers': {
            'QuestionList': 'Spørgsmål:'
        },
        'QuestionTypeCategory': {
            'value1': 'Textbox',
            'value2': 'Multi Choice',
            'value3': 'Single Choice',
            'value4': 'Rating'
        },
        'BUTTONS': {
            'NEWPROJECTOFFER': 'Nyt Sag tilbud',
            'AddQuestion': 'Tilføj spørgsmål',
            'SendReminder': 'Send påmindelse',
            'Save': 'Gem',
            'Cancel': 'Gå tilbage',
            'Text': 'Tekst',
            'Add': 'Tilføj',
            'HideAnswer': 'Skjul svar'
        },
        'FIELDS': {
            'Question': 'tekst',
            'SrNo': 'Sr nr.',
            'Type': 'Type',
            'Answer': 'Svar',
            'WithTextbox': 'Med tekstboks',
            'ReminderMsg': 'Påmindelse Besked',
            'DragAndDropFile':'Træk og slip filen her',
            'Or':'Eller',
            'BrowseForFile':'Søg efter fil',
            'EmailTemplate':'E-mail skabelon'
        },
        'VALIDATIONS': {
            'QuestionRequired': 'Spørgsmål påkrævet',
            'CoWorkerRequired': 'Medarbejder påkrævet',
            'Not-Found-Worker': 'Medarbejder ikke fundet',
            'ReminderMsgRequired': 'Påmindelse Besked påkrævet',
        },
        'PlaceHolder': {
            'SelectCoWorker': 'Medarbejder',
            'Search-worker': 'Søg Medarbejder',
        },
        'MESSAGES': {
            'NoQuestionAnswerFound': 'Ingen Spørgsmål Fundet.',
            'AddTypeList': 'Tilføj mindst en værdi i typelisten.',
            'AddTypeListItem': 'Tilføj værdi til typelisten.',
            'Saved': 'Gemt succesfuldt.',
        },
        'TOOTIPORTITLE':{
            'ViewOrEdit':'Se eller rediger',
            'Delete':'Slet',
        },
        'ToolTip': {
            'SendReminderBySMS': 'Send påmindelse med Sms',
            'SendReminderByEmail': 'Send påmindelse med e-mail',
            'SendReminderByNotification': 'Send påmindelse med notifikationer',
        }
    }
}